module.exports = __webpack_public_path__ + "static/media/peter.3afe06c1.png";